import {
    Component,
    EventEmitter,
    Input,
    Output,
    ChangeDetectionStrategy,
} from '@angular/core';

@Component({
    selector: 'app-evaluation-guide-preview',
    templateUrl: './evaluation-guide-preview.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class EvaluationGuidePreviewComponent {
    @Input() public guide?: string;

    @Input() public previewLimit = 100;

    @Output() public openGuide = new EventEmitter<string>();

    public get guideText(): string {
        return (this.guide ?? '').trim();
    }

    public get hasOverflow(): boolean {
        return this.guideText.length > this.previewLimit;
    }

    public get previewText(): string {
        if (!this.guideText) return '-';
        if (!this.hasOverflow) return this.guideText;
        return this.guideText.slice(0, this.previewLimit);
    }

    public processOpenGuide(): void {
        if (!this.guideText) return;
        this.openGuide.emit(this.guideText);
    }
}
